import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import {
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from '@heroicons/react/24/outline';
import { useCJHistory } from 'containers/CahierJournal/queries/historyAtoms';
import { useUndoCJ } from 'containers/CahierJournal/queries/useUndoCJ';
import { useRedoCJ } from 'containers/CahierJournal/queries/useRedoCJ';
import { useTranslation } from 'react-i18next';
import Tooltip2 from 'components/Tooltip2';

interface Props {
  large?: boolean;
  minimal?: boolean;
}

export function UndoRedo(props: Props) {
  const { large, minimal } = props;
  const { isFutureEmpty, isPastEmpty } = useCJHistory();
  const undo = useUndoCJ();
  const redo = useRedoCJ();
  const { t } = useTranslation(['common']);
  return (
    <>
      <Tooltip2 label={t('common:buttons.undo')} disabled={isPastEmpty}>
        <Button
          title={t('common:buttons.undo')}
          aria-label="Revenir en arrière"
          large={large}
          minimal={minimal}
          disabled={isPastEmpty}
          onClick={() => undo()}
          icon={ArrowUturnLeftIcon}
        />
      </Tooltip2>
      <Tooltip2 label={t('common:buttons.redo')} disabled={isFutureEmpty}>
        <Button
          aria-label="Revenir en avant"
          title={t('common:buttons.redo')}
          disabled={isFutureEmpty}
          large={large}
          minimal={minimal}
          onClick={() => redo()}
          icon={ArrowUturnRightIcon}
        />
      </Tooltip2>
    </>
  );
}
